import { v4 as uuid } from "uuid";
import { useContext, useState } from "react";
import Card from "../../../components/card/card";
import { logoutUser } from "../../../../../actions";
import { BookedAppointmentStyled } from "./appointment-booked.styles";
import { CompletedFlowIcon } from "../../../../../assets/svgComponents";
import {
  initialState,
  USER_APPOINTMENT_ACTIONS,
  UserAppointmentContext,
} from "../../../context/user-appointment-context";
import { addNotification } from "../../../../../store/slices/ui-slice";
import { useAppDispatch } from "../../../../../store/hooks";
import { Box } from "@mui/material";
import { Button, DangerButton } from "../../../../../components/button/button";

const BookedAppointment = () => {
  const {
    state: { activeStep },
    userDispatcher,
  } = useContext(UserAppointmentContext);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onHandleLogout = async () => {
    setIsLoading(true);
    try {
      await logoutUser();
      localStorage.removeItem("userAppToken");
      userDispatcher({
        type: USER_APPOINTMENT_ACTIONS.RESET_STATE,
      });
    } catch (err: any) {
      dispatch(
        addNotification({
          id: uuid(),
          type: "error",
          message: err.message || "An unexpected error occurred.",
        })
      );
    } finally {
      setIsLoading(false);
    }
  };

  const onBookMoreAppointments = () => {
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_PETS,
      payload: initialState.selectedPets,
    });

    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_TIME_SLOT,
      payload: initialState.selectedTimeSlot,
    });

    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT,
      payload: initialState.selectedClientAccount,
    });
    userDispatcher({
      type: USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP,
      payload: 9,
    });
  };

  return (
    <Card
      title={"Congratulations!"}
      description={"Congratulations! Your appointment has been booked."}
      progress={activeStep * 6}
    >
      <BookedAppointmentStyled>
        <CompletedFlowIcon />
        <Box className="btn-wrapper">
          <DangerButton
            variant="contained"
            onClick={onHandleLogout}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Logout
          </DangerButton>
          <Button onClick={onBookMoreAppointments} disabled={isLoading}>
            Book more appointments
          </Button>
        </Box>
      </BookedAppointmentStyled>
    </Card>
  );
};

export default BookedAppointment;
